import { type FeatureCategory, PropertyTypeEnum, type FeatureEnum, type FeatureObject } from "./CRMEnums";
import type { Property } from "./property";

export type SystemEnums = {
  categories: Record<FeatureCategory, string>;
  developmentStage: Record<string, string>;
  displayAddress: Record<string, string>;
  features: Record<FeatureEnum, FeatureObject>;
  frontDeskHours: Record<string, string>;
  propertyTypes: Record<PropertyTypeEnum, string>;
  role: Record<string, string>;
  transactionTypes: Record<string, string>;
};


export function getAreaLabel(propertyType: PropertyTypeEnum, displayOnCard = false) {
  const areaOptions = {
    land: 'Área do terreno',
    condo_land: 'Área do terreno',
    house: 'Área construída',
    condo_house: 'Área construída'
  } as Record<PropertyTypeEnum, string>;

  const cardAreaOptions = {
    land: 'terreno',
    condo_land: 'terreno',
    house: 'construídos',
    condo_house: 'construídos'
  } as Record<PropertyTypeEnum, string>;

  const options = displayOnCard ? cardAreaOptions : areaOptions;

  const fallback = displayOnCard ? 'Útil' : 'Área útil';

  return options[propertyType] || fallback;
}

export const hiddenFields = readonly<Record<PropertyTypeEnum, (keyof Property)[]>>({
  [PropertyTypeEnum.LAND]: [
    'bathrooms',
    'bedrooms',
    'parkingSpots',
    'suites',
    'totalArea',
    'launchDate'
  ],
  [PropertyTypeEnum.COMMERCIAL]: ['bedrooms', 'suites'],
  [PropertyTypeEnum.CONDO_HOUSE]: [],
  [PropertyTypeEnum.CONDO_LAND]: [  
    'bathrooms',
    'bedrooms',
    'suites',
    'totalArea',
    'parkingSpots',
    'launchDate'
  ],
  [PropertyTypeEnum.HOUSE]: [],
  [PropertyTypeEnum.VILLAGE_HOUSE]: [],
  [PropertyTypeEnum.APARTMENT]: [],
  [PropertyTypeEnum.DUPLEX]: [],
  [PropertyTypeEnum.FLAT]: [],
  [PropertyTypeEnum.GARDEN]: [],
  [PropertyTypeEnum.LOFT]: [],
  [PropertyTypeEnum.PENTHOUSE]: [],
  [PropertyTypeEnum.STUDIO]: [],
  [PropertyTypeEnum.TRIPLEX]: []
});

export function propertyCountableExistsOnPropertyType(
	propertyType: PropertyTypeEnum,
	propertyCountableName: keyof Property
): boolean {
  return !hiddenFields[propertyType]?.includes(propertyCountableName);
}
